import React, {useEffect} from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import * as uuid from "uuid";

import {getCartItemObject, getFeatureUnit} from "../../../misc/helpers";
import Quantity from "../../ui/quantity";
import {MEASURE_UNITS} from "../../sqft/constants";
import {COUNTERTOP_GROUP} from "../../kvComponent/core/constants";
import {setRowItems} from "../../../actions/selectionFunctions";


const RowItemQuantity = (props) => {

  const {currentFeature, fabricatorData, intl, rowItems, setRowItems, qtActiveCategory, cartItemEditFeature,
    activeQuoteIndex} = props;
  const fabricatorSettings = fabricatorData.settings;

  const availableMeasureUnits = [...COUNTERTOP_GROUP, "edge", "edge_profile", "center_island_edge"];
  const unit = getFeatureUnit(currentFeature, intl, fabricatorData);
  const allowDecimals = (fabricatorSettings.measureUnit === MEASURE_UNITS.Metric) && (
    availableMeasureUnits.includes(currentFeature.partId) || ["lm", "sm", "mm"].some(um => um === unit.toLowerCase())
  );

  useEffect(() => {
    if (cartItemEditFeature && (cartItemEditFeature.cartFeature.dbFeature.id === currentFeature.dbFeature.id)
      && !rowItems.some(cItem => cItem.cartFeature.dbFeature.id === currentFeature.dbFeature.id)) {
      setRowItems([...rowItems, getRowItemObject(cartItemEditFeature.quantity)])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItemEditFeature, currentFeature]);

  const getRowItemObject = (quantity) => {
    let cartItemObject = getCartItemObject(currentFeature, quantity, qtActiveCategory);
    cartItemObject.currentQuote = activeQuoteIndex;
    cartItemObject.id = uuid.v4();
    const relatedFeatures = currentFeature.getFeatureRelatedFeatures();
    if (Array.isArray(relatedFeatures) && relatedFeatures.length) {
      cartItemObject.showRowRelatedItems = true;
    }
    return cartItemObject
  }

  const handleChangeItemQuantity = (value) => {
    const newRowItems = [...rowItems];
    const existingItemIndex = newRowItems.findIndex(rItem => rItem.cartFeature.dbFeature.id === currentFeature.dbFeature.id);
    const currentQuantity = existingItemIndex > -1 ? newRowItems[existingItemIndex].quantity : undefined;
    const resolvedValue = (value === 1 && !currentQuantity)
      ? (currentFeature.dbFeature.defaultQuantity || 1)
      : value;
    ///row view should set default quantity bu the default on first + click
    if (existingItemIndex > -1) {
      newRowItems[existingItemIndex].quantity = resolvedValue;
    } else {
      newRowItems.push(getRowItemObject(resolvedValue))
    }
    setRowItems([...newRowItems.filter(rowItem => rowItem.quantity)])
  }


  const thisFeature = rowItems.find(rItem => rItem.cartFeature.dbFeature.id === currentFeature.dbFeature.id);
  const quantity = thisFeature ? thisFeature.quantity : window.inputIsFocused ? "" : 0;

  return (
    <Quantity squared={true}
              allowDecimals={allowDecimals}
              size={"small"}
              pulseFeatureInfoQuantity={false}
              changeValue={handleChangeItemQuantity}
              value={quantity}/>
  )
};

RowItemQuantity.propTypes = {
  currentFeature: PropTypes.object.isRequired,
};

const mapStateToProps = (store) => {
  const {rowItems} = store.selectionState;
  const {cartItemEditFeature} = store.cartState;
  const {activeQuoteIndex} = store.quotesState;

  return {
    rowItems,
    fabricatorData: store.fabricatorState,
    qtActiveCategory: store.qtState.qtActiveCategory,
    cartItemEditFeature,
    activeQuoteIndex,
  };
};

const mapDispatchToProps = {
  setRowItems
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RowItemQuantity)
)
